module.exports = "<b-form-textarea v-bind=\"$attrs\" rows=\"3\" v-model=\"value\"></b-form-textarea>\n"